<script lang="ts" setup>
import { mergeProps } from 'vue'

const {
  value = undefined,
  disabled = false,
  size = 68,
  active = false,
} = defineProps<{
  icon: string
  text: string
  value?: string | number
  disabled?: boolean
  size?: number
  active?: boolean
}>()
</script>

<template>
  <v-hover>
    <template #default="{ isHovering, props: hoverProps }">
      <v-btn
        v-bind="mergeProps(hoverProps, $attrs)"
        :value="value"
        :disabled="disabled"
        :text="text"
        :prepend-icon="icon"
        variant="text"
        stacked
        :min-width="size"
        :min-height="size"
        :width="size"
        :height="size"
        rounded="lg"
        :color="active && !disabled ? 'primary' : undefined"
        class="text-body-2 text-uppercase font-weight-bold"
        :class="{
          'text-gray-500': disabled,
          'bg-primary-50': isHovering && !disabled && !active,
        }"
      />
    </template>
  </v-hover>
</template>
